import { useEffect, useState } from "react";
import { admin } from "../../lib/api";
import { inr } from "../../lib/format";
import { panel, PageHead } from "../ui";

export default function Customers() {
  const [list, setList] = useState([]);
  useEffect(() => { admin.get("/admin/customers").then((r) => setList(r.data)); }, []);
  return (
    <div>
      <PageHead title="Customers" />
      <div className={`${panel} overflow-x-auto`}>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase tracking-widest text-zinc-500 border-b border-zinc-800">
            <th className="p-3">Customer</th><th className="p-3">Location</th><th className="p-3">Orders</th><th className="p-3">Last Order</th><th className="p-3 text-right">Lifetime Value</th>
          </tr></thead>
          <tbody>
            {list.map((c) => (
              <tr key={c.email} className="border-b border-zinc-900">
                <td className="p-3"><p className="text-zinc-100">{c.name}</p><p className="text-[11px] text-zinc-600">{c.email}</p></td>
                <td className="p-3 text-zinc-400">{c.location}</td>
                <td className="p-3 text-zinc-300">{c.orders}</td>
                <td className="p-3 text-zinc-500">{(c.last_order || "").slice(0, 10)}</td>
                <td className="p-3 text-right text-white">{inr(c.ltv)}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-zinc-500">No customers yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
